import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'app-acceuil',
  templateUrl: './acceuil.component.html',
  styleUrls: ['./acceuil.component.scss'],
  standalone: false
})
export class AccueilComponent implements OnInit {
  private readonly tokeninfo: any;
  private readonly keycloak = inject(Keycloak);

  // constructor(private keycloakService: KeycloakService, private http: HttpClient, private router: Router) {
  //   this.keycloakService.init().then(() => console.log('Keycloak is initialized'));
  // }

  constructor(private readonly router: Router) {
  }

  ngOnInit(): void {
  }

  //   getResource() {
  //     this.keycloakService.getToken().then(token => {
  //       const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);
  //       this.http.get('https://localhost:8443/protected-resource', { headers }).subscribe(response => {
  //         console.log(response);
  //       });
  //     });
  //   }

  //   login(username: string, password: string): Observable<any> {
  //     const httpOptions = {
  //       headers: new HttpHeaders({
  //         'Content-Type': 'application/x-www-form-urlencoded'
  //       })};

  //     const params = new HttpParams({
  //       fromObject: {
  //         grant_type: 'password',
  //         client_id: 'exploreKeycloak',
  //         username: username,
  //         password: password,
  //         scope: 'openid'
  //       }
  //     });

  //     return this.http.post('/auth/realms/exploreKeycloak/protocol/openid-connect/token', params, httpOptions)
  //       .pipe(tap((response: any) => {
  //         this.tokeninfo = jwtDecode(response.access_token);
  //       }));
  // }

  ShowProfile() {
    this.router.navigate(['/profile']);
  }

  // login() {
  //   this.keycloak.login();
  // }

  // logout() {
  //   this.keycloak.logout();
  // }
}
